export const FINNISH_TRANSLATIONS = {
    sammio: {
        site: {
            name: 'Sammio - Säteilyturvakeskus (STUK)',
            name_short: 'Sammio'
        },
        search: 'Haku',
        search_filters: {
          tip: 'Rajaa hakutuloksia valitsemalla aihealueita'
        },
        search_redirect: 'Haku',
        search_card: 'Haku',
        help: 'Ohje',
        announcement: "Ajankohtaista",
        accessibility: 'Saavutettavuusseloste',
        bookmarks: {
            title: 'Muistilista',
            title_field: 'Muistilistan nimi',
            add_all: 'Valitse kaikki tulokset muistilistalle',
            clear_all: 'Poista kaikki tulokset muistilistasta',
            back_to_search_results: 'Takaisin edellisiin hakutuloksiin',
            reorder: 'Muokkaa tulosten järjestystä',
            empty: 'Muistilista tyhjä.',
            loaded_empty: 'Annettua muistilistaa ei löytynyt.',
            show_in_cards: 'Näytä muistilistassa',
            prompt_add_x_to_bookmarks: 'Haluatko varmasti lisätä {count} tulosta muistilistalle?',
            prompt_clear_bookmarks: 'Haluatko varmasti tyhjentää muistilistan?',
            bookmark_selected_info: 'Kirjainmerkki valittu. Käytä nuolinäppäimiä siirtääksesi kirjainmerkin haluttuun kohtaan. Paina ESC-näppäintä poistuaksesi kirjainmerkkien muokkaustilasta.',
            bookmark_not_selected_info: 'Kirjainmerkkiä ei ole valittu. Käytä välilyöntiä valitaksesi siirrettävän kirjainmerkin. Paina ESC-näppäintä poistuaksesi kirjainmerkkien muokkaustilasta.',
            bookmark_moved_up: 'Kirjainmerkkiä siirretty ylöspäin. Uusi sijainti on {location}',
            bookmark_moved_down: 'Kirjainmerkkiä siirretty alaspäin. Uusi sijainti on {location}',
            add_to_bookmarks: 'Lisää kohde muistilistalle',
            added_to_bookmarks: 'Kohde lisätty muistilistalle',
            remove_from_bookmarks: 'Poista kohde muistilistasta',
            removed_from_bookmarks: 'Kohde poistettu muistilistasta',
            items: 'Kohdetta'
        },
        bookmarks_get: {
            title: 'Muistilista'
        },
        statutes: {
            title: 'Säädökset ja määräykset',
            side_navigation_go_to: 'Hyppää sivupalkin aktiivisen sivun kohdalle',
            side_navigation_no_results: 'Sivupalkissa ei havaittu aktiivisia sivuja. Valitse uusi sivu.'
        },
        statutes_root: {
            title: 'Säädökset ja määräykset'
        },
        statutes_card: {
            title: 'Säädökset ja määräykset'
        },
        frequentsearches: {
            title: "Valmishaut"
        },
        subsectionTitle: 'Vaatimus',
        subsection: 'momentti',
        justification: 'Perustelu',
        guidance: 'Ohje',
        export_pdf: 'Tallenna PDF',
        share: 'Jaa',
        print: 'Tulosta',
        show: 'Hae seuraavista',
        target_fields: 'Hae sanaa seuraavista',
        filter_results: 'Rajaa tuloksia',
        act: 'Laki',
        decree: 'Asetus',
        regulation: 'Määräys',
        by_radiation_act: 'säteilylain',
        by_subsection: 'momentin',
        provision: 'Perussäännös',
        issued: 'säädetty',
        regulated: 'määrätty',
        under: 'nojalla',
        related_decrees: 'Tarkemmat säännökset',
        decrees: 'Säädökset',
        related_regulations: 'Tarkemmat määräykset',
        regulations: 'Määräykset',
        related_decrees_and_regulations: 'Tarkemmat säännökset ja määräykset',
        open: 'Avaa',
        openMenu: 'Avaa valikko',
        close: 'Sulje',
        closeMenu: 'Sulje valikko',
        yes: 'Kyllä',
        no: 'Ei',
        clear: 'Tyhjennä',
        copy: "Kopioi",
        link_to_page: 'Linkki sivulle',
        do_search: 'Hae',
        remove: 'Poista',
        removed: 'Poistettu',
        filter: 'Rajaus',
        remove_filter: 'Poista rajaus',
        keyword: 'Hakusana',
        searched_with_synonym: 'Näytetään tulokset myös hakusanalla',
        active_filters: 'Rajaukset',
        show_x_results: 'Näytetään {count} tulosta',
        added_x_results: 'Lisätty {count} tulosta',
        added_one_result: 'Lisätty 1 tulos',
        clear_filters: 'Tyhjennä kaikki rajaukset',
        search_field_placeholder: 'Hae hakusanalla vaatimuksia, perusteluja ja ohjeita',
        and: 'ja',
        this_law_contains: 'Tässä laissa tarkoitetaan',
        save: 'Tallenna',
        cancel: 'Peruuta',
        selected: 'Valittu',
        unselected: 'valitsematon',
        url_copied_to_clipboard: 'Osoite kopioitu leikepöydälle.',
        attachments_title: 'Liitteet',

        errors: {
            common_error: "Hups, jotain meni pieleen. Ole hyvä ja yritä hetken päästä uudelleen."
        },
        navigation: {
            title: "Päänavigaatio",
            site_pages: "Sivuston sivut",
            logo_text: "Sammio - Hakusivulle",
            saados:"Säädökset valikko",
            haku: "Hakusuodattimet",
            muistilista: 'Muistilista',
            menu: "Valikko",
            usein_haetut: "Valmishaut valikko"
        },
        dropdown: {
            select_language: "Valitse kieli",
            description:  "Valitse sivuston kieli",
            change_to_language: "Vaihda kieleksi {lang}"
        },
        pagination: {
            next: 'Siirry seuraavalle sivulle',
            previous: 'Siirry edelliselle sivulle',
            goto_page: 'Siirry sivulle {0}',
            wrapper: 'Hakutulosten sivutus',
            current: 'Nykyinen sivu {0}',
        },
        loading: {
            on: 'Odota, ladataan.',
            done: 'Lataus on valmistunut.'
        },
        page_top: 'Sivun alkuun',
        language: {
            fi: "Suomi",
            sv: "Ruotsi",
            en: "Englanti"
        },
        news: {
            title: "Ajankohtaista",
            no_publications: "Ei julkaistuja tiedotteita",
            loading: "Haetaan tiedotteita...."
        }
    }
};
